<template>
  <div :class="cls">
    <slot />
  </div>
</template>
<script>
const prefixCls = 'tt-loading'
export default {
  name: 'Loading',
  props: {
    theme: {
      type: 'theme-dark' | 'theme-light',
      default: 'theme-dark'
    },
    size: {
      type: 'sm' | 'md' | 'lg',
      default: 'lg'
    }
  },
  computed: {
    cls() {
      return {
        [prefixCls]: true,
        [`${prefixCls}-size--${this.size}`]: true,
        [`${prefixCls}-${this.theme}`]: true
      }
    }
  }
}
</script>
<style lang="less">
.size(@size, @border) {
  width: @size;
  height: @size;
  border-radius: @size;
  border-width: @border;
  border-style: solid;
}
.tt-loading {
  .size(54px, 2px);
  position: relative;
  display: inline-block;
  vertical-align: middle;
  border-left-color: var(--active-color);
  transform: translateZ(0);
  animation: load8 1.1s infinite linear;
  &-theme-dark {
    border-top-color: rgba(255, 255, 255, 0.2);
    border-right-color: rgba(255, 255, 255, 0.2);
    border-bottom-color: rgba(255, 255, 255, 0.2);
  }
  &-theme-light {
    border-top-color: rgba(0, 0, 0, 0.2);
    border-right-color: rgba(0, 0, 0, 0.2);
    border-bottom-color: rgba(0, 0, 0, 0.2);
  }
  &-size--lg {
    .size(54px, 4px);
  }
  &-size--md {
    .size(40px, 4px);
  }
  &-size--sm {
    .size(20px, 2px);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
